import React from 'react'
import { Box, Grid } from 'theme-ui'

import CardBox from './../../molecules/CardBox'
import { CardBoxListProps } from './types'

const CardBoxList: React.FC<CardBoxListProps> = ({ data }) => {
  return (
    <Grid as="ul" variant="cardBoxList.list">
      {data.map((item) => {
        return (
          <Box as="li" key={item.key} variant="cardBoxList.item">
            <CardBox {...item} />
          </Box>
        )
      })}
    </Grid>
  )
}

export default CardBoxList
